import React, { useState, useEffect } from "react";
import { FOREGROUNDCOLOR } from "../../helpers/colors";
import {
  CreateUserAndProfile,
  SetPassword,
} from "../../services/AccountService";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { Password } from "primereact/password";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { GetInvitationByInvitationId } from "../../services/InvitationService";

const InvitationPasword = () => {
  const formik = useFormik({
    initialValues: {
      password: "",
      passwordConfirm: "",
    },
    validationSchema: Yup.object().shape({
      password: Yup.string().required("لطفا کلمه عبور را وارد کنید"),
      passwordConfirm: Yup.string().test(
        "match",
        "تکرار کلمه عبور همخوانی ندارد",
        function (passwordConfirm) {
          return passwordConfirm === this.parent.password;
        }
      ),
    }),
    onSubmit: (values) => {
      RegisterUserAsync(values);
    },
  });

  const [getInvitationData, SetInvitationData] = useState<any>(null);
  const params = useParams();
  async function GetInvitationByInvitationIdAsync() {
    await GetInvitationByInvitationId(params.id).then((p) => {
      console.log(p.data.data);
      if (p.data.data === undefined || p.data.data === null) {
        navigate("/InvitationNotFound");
      }
      SetInvitationData(p.data.data);
    });
  }
  useEffect(() => {
    (setActiveIndex as any)(1);
    GetInvitationByInvitationIdAsync();
  }, []);
  const setActiveIndex = useOutletContext();
  const navigate = useNavigate();

  const header = <h6> </h6>;
  const footer = (
    <React.Fragment>
      <Divider />
      <p className="mt-2">برای ساختن کلمه عبور ایمن</p>
      <ul className="pl-2 ml-2 mt-0" style={{ lineHeight: "1.5" }}>
        <li> حداقل شامل یک حرف کوچک باشد</li>
        <li> حداقل شامل یک حرف بزرگ باشد</li>
        <li> حداقل شامل یک عدد باشد</li>
        <li> حداقل شامل 8 کاراکتر باشد</li>
      </ul>
    </React.Fragment>
  );

  const RegisterUserAsync = async (input: any) => {
    try {
      if (getInvitationData) {
        await CreateUserAndProfile({
          phoneNumber: getInvitationData.phoneNumber,
          password: input.password,
          firstName: getInvitationData.firstName,
          lastName: getInvitationData.lastName,
        }).then((p) => {
          console.log(p);

          if (p.data.statusCode === 201) {
            (setActiveIndex as any)(2);
            localStorage.setItem("token", p.data.data.token);
            navigate(`/ViewInvitation/InvitationRequest/${params.id}`);
          }
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    (setActiveIndex as any)(1);
  }, []);

  return (
    <>
      <div
        className="container mt-2 col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 "
        style={{
          height: "600px",
          display: "inline-flex",
        }}
      >
        <div style={{ display: "inline-flex" }}></div>
        <div className="col-12">
          {}
          <div className="mt-5 col-12 px-2">
            <h5 style={{ color: FOREGROUNDCOLOR }}>تعیین کلمه عبور </h5>
          </div>
          <div className="col-12 mt-4 px-2" style={{ width: "100%" }}>
            <span className="p-float-label" style={{ width: "100%" }}>
              <Password
                inputClassName="p-input-icon-right"
                toggleMask
                className="w-full"
                style={{ width: "100%" }}
                dir="rtl"
                id="password"
                {...formik.getFieldProps("password")}
                header={header}
                footer={footer}
                promptLabel="کلمه عبور را وارد کنید"
                weakLabel="ضعیف"
                mediumLabel="متوسط"
                strongLabel="ایمن"
                inputStyle={{ width: "100%" }}
              />

              <label
                style={{ right: "10px", left: "unset" }}
                htmlFor="password"
              >
                کلمه عبور
              </label>
            </span>
            {formik.touched.password && formik.errors.password ? (
              <b style={{ fontSize: "0.65rem" }} className="my-1 text-danger">
                {formik.errors.password}{" "}
              </b>
            ) : null}
          </div>
          <div className="col-12 mt-4 px-2" style={{ width: "100%" }}>
            <span className="p-float-label" style={{ width: "100%" }}>
              <Password
                inputClassName="p-input-icon-right"
                toggleMask
                className="w-full"
                style={{ width: "100%" }}
                dir="rtl"
                id="passwordConfirm"
                {...formik.getFieldProps("passwordConfirm")}
                header={header}
                footer={footer}
                promptLabel="کلمه عبور را وارد کنید"
                weakLabel="ضعیف"
                mediumLabel="متوسط"
                strongLabel="ایمن"
                inputStyle={{ width: "100%" }}
              />

              <label
                style={{ right: "10px", left: "unset" }}
                htmlFor="passwordConfirm"
              >
                تکرار کلمه عبور
              </label>
            </span>
            {formik.touched.passwordConfirm && formik.errors.passwordConfirm ? (
              <b style={{ fontSize: "0.65rem" }} className="my-1 text-danger">
                {formik.errors.passwordConfirm}{" "}
              </b>
            ) : null}
          </div>

          <div className="col-12 mt-2 px-2" style={{ width: "100%" }}>
            <Button
              onClick={formik.submitForm}
              label="ثبت کلمه عبور"
              style={{ width: "100%" }}
              className="mt-3 p-button-success"
            />
          </div>
          {/* <div className="col-12 mt-3 px-2" style={{ width: "100%" }}>
            <span style={{ color: "blueviolet" }}> حساب کاربری دارید ؟</span>
            <span style={{ color: "green", cursor: "pointer" }}>
              &nbsp; وارد شوید
            </span>
          </div> */}
        </div>
      </div>
      <div
        className="d-xl-inline-flex d-none col-12 col-xs-12 col-sm-12 col-md-12 col-lg-5 col-xl-5 col-xxl-5"
        style={{ display: "inline-flex" }}
      >
        {/* <img
          // src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.svg"
          src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.webp"
          alt="سن ایچ"
        /> */}
      </div>
    </>
  );
};
export default InvitationPasword;
